import { useContext } from 'react';
import { DashboardPageFormTabs, type DashboardPageFormTabsProps } from '@shigo-ui/dashboard-ui';

import { EditorSectionContext } from './editorSectionContext';
import type { EditorSectionControls } from './useEditorSection';

/**
 * `DashboardPageFormTabs` bound to the editor's section. It is the only component that reads the
 * section, and its `children` keep their identity, so a switch skips re-rendering the panels.
 */
export function EditorSectionTabs<T extends string>({
  controls,
  children,
  ...props
}: Omit<DashboardPageFormTabsProps, 'value' | 'defaultValue' | 'onValueChange'> & {
  controls: EditorSectionControls<T>;
}) {
  const routed = useContext(EditorSectionContext);
  const requested = controls.localSection ?? routed?.section;
  const section = controls.sections.find((value) => value === requested) ?? controls.defaultSection;
  return (
    <DashboardPageFormTabs {...props} value={section} onValueChange={controls.setSection}>
      {children}
    </DashboardPageFormTabs>
  );
}
